export const getProductData = (store) => store.product.product;
export const getCategoryId = (store) => store.product.categoryId;
export const getProductName = (store) => store.product.name;
export const getReletedProduct = (store) => store.product.reletedProduct;
export const getReletedProductData = (store) =>
  store.product.reletedProductData;
